<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Seja bem vindo(a) {{ usuario.nome }}!</h3>
            <br />
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
            <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <h2>Informações e notícias</h2>
            <carousel :navigationEnabled="true" v-if="informacoes  !== undefined" :perPage="3">
              <slide
                v-for="(informacao, index) in informacoes"
                :key="informacao.id"
                class="p-2"
              >
                <b-card
                  @click="modalinformacao(informacao.id)"
                  :img-src="informacao.imagem_capa"
                  img-alt="Image"
                  img-top
                  tag="article"
                  style="max-width: 260px;max-heigth: 260px;"
                >
                <b-card-body class="limit-body">
                      <b-card-title>{{ informacao.titulo }}</b-card-title>
                  <b-card-text  class="limit-body">
                    {{ verificaTexto(informacao.texto) }}
                  </b-card-text>
                </b-card-body>
                </b-card>
              </slide>
            </carousel>
          </b-col>
          <b-col v-if="informacoes !== undefined" cols="11 text-right">
            <a
              @click="navigate('informacoes-noticias')"
              style="color: sandybrown; font-size: 16px"
              class="action"
              ><strong> Ver Todos </strong></a
            >
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12">
            <h2>Programas da minha cidade</h2>
            <carousel v-if="programas !== undefined" :navigationEnabled="true" :perPage="3">
              <slide
                v-for="programa in programas"
                :key="programa.id"
                class="p-2"
              >
                <b-card
                  @click="modalprograma(programa.id)"
                  :img-src="programa.imagem_capa"
                  img-alt="Image"
                  img-top
                  tag="article"
                  style="max-width: 260px;max-heigth: 260px;"
                >
                <b-card-body class="limit-body">
                      <b-card-title>{{ programa.nome }}</b-card-title>
                  <b-card-text  class="limit-body">
                    {{ verificaTexto(programa.texto) }}
                  </b-card-text>
                </b-card-body>
                </b-card>
              </slide>
            </carousel>
          </b-col>
          <b-col v-if="informacoes !== undefined" cols="11 text-right">
            <a
              @click="navigate('programas-municipios-listar')"
              style="color: sandybrown; font-size: 16px"
              class="action"
              ><strong> Ver Todos </strong></a
            >
          </b-col>
        </b-row>
      </b-card-body>
      <span v-if="false">
        <b-row>
          <b-col md="6">
            <h3>Rodas de conversa</h3>
            <p>Escolha uma das datas para participar da roda de conversa</p>
            <table
              aria-rowcount="4"
              id="my-table"
              aria-busy="false"
              aria-colcount="7"
              class="
                table table-responsive-sm table-bordered table-striped table-sm
              "
            >
              <thead>
                <tr>
                  <th scope="col">Dia</th>
                  <th scope="col">Tema</th>
                  <th scope="col">Situação de Presença</th>
                  <th scope="col">Participar?</th>
                </tr>
              </thead>
              <tbody v-if="arrayRodas !== undefined">
                <tr v-for="roda in arrayRodas" :key="roda.id">
                  <td>{{ formatDate(roda.data) }}</td>
                  <td>{{ verificaTema(roda.tema) }}</td>
                  <td>
                    {{ buscaSituacao(roda.inscricoes) }}
                  </td>
                  <td>
                    <span
                      v-if="
                        moment(roda.data_hora_minutos).format(
                          'YYYY-MM-DD hh:mm'
                        ) <= moment().format('YYYY-MM-DD hh:mm')
                      "
                    >
                      <span
                        v-if="
                          buscaSituacao(roda.inscricoes) !== 'Não Compareceu' &&
                          buscaSituacao(roda.inscricoes) !== 'Não Participou'
                        "
                      >
                        <span
                          v-if="
                            roda.inscricoes.filter(
                              (e) => e.usuario_id === usuarioCorrente
                            ).length > 0
                          "
                        >
                          <a
                            class="btn btn-sm btn-secondary action"
                            title="Sair"
                            @click="sair(roda.id)"
                          >
                            <i class="fa fa-toggle-on"></i>
                          </a>
                        </span>
                        <span v-else>
                          <button
                            class="btn btn-sm btn-secondary action"
                            :disabled="roda.vagas == 0"
                            title="Participar"
                            @click="participar(roda.id)"
                          >
                            <i class="fa fa-toggle-off"></i>
                          </button>
                        </span>
                      </span>
                    </span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="action">
                  <td colspan="7">Nenhum registro de rodas de conversa...</td>
                </tr>
              </tbody>
            </table>
            <paginationAlternative
              v-show="arrayRodas !== undefined"
              :totalPorPagina="totalPorPagina"
              :resource="resource2"
            ></paginationAlternative>
          </b-col>
        </b-row>
      </span>

      <b-modal
        title="Programa do Município"
        size="md"
        :hide-footer="true"
        v-model="modalprog"
      >
        <b-card
          style="width: 28rem"
          :img-src="prog.imagem_capa"
          img-alt="Card image"
          img-height="300"
          img-width="300"
          img-top
          class="mb-3"
        >
          <a>
            <b-card-text>
              <p>
                <b>{{ prog.nome }}</b>
              </p>
              <p>{{ prog.texto }}</p>
            </b-card-text>
          </a>
          <div>
            <b-button block variant="primary" @click="abrirLink(prog.link)">
              <span>Link</span>
            </b-button>
          </div>
          <b-card-footer class="p-12">
          <b-button variant="secondary" @click="fecharmodalprog"
            ><i class="fa fa-mail-reply-all"></i> Voltar</b-button
          >
        </b-card-footer>
        </b-card>
      </b-modal>

      <b-modal
        title="Informação e Notícia"
        size="sm"
        :hide-footer="true"
        v-model="modalinfo"
      >
        <b-card
          :img-src="info.imagem_capa"
          img-alt="Card image"
          img-height="300"
          img-width="300"
          img-top
          align="center"
          class="mb-3 text-center"
        >
          <a >
            <b-card-text>
              <p>
                <b>{{ info.titulo }}</b>
              </p>
              <p>{{ info.texto }}</p>
            </b-card-text>
          </a>
          <b-card-footer class="p-12">
          <b-button variant="secondary" @click="fecharmodalinfo"
            ><i class="fa fa-mail-reply-all"></i> Voltar</b-button
          >
        </b-card-footer>
        </b-card>
      </b-modal>
    </b-card>
  </span>
</template>

<script>
import { eventType } from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'
import PaginationAlternative from '@/components/shared/PaginationAlternative'
import Vue from 'vue'
import moment from 'moment'
import { Carousel, Slide } from 'vue-carousel'

miniToastr.init()
Vue.prototype.moment = moment

export default {
  components: {
    PaginationAlternative,
    Carousel,
    Slide
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'V') {
      this.$store.dispatch('buscarEstados')
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.loadInformacoes()
      this.loadProgramas()
    } else {
      this.$router.push('/')
    }
  },
  data () {
    return {
      usuarioCapacitado: false,
      modalprog: false,
      prog: [],
      info: [],
      modalinfo: false,
      totalPorPagina: 10,
      disable_buttons: false,
      resource2: 'roda',
      arrVerificaLotacao: [],
      informacoes: [],
      programas: [],
      arrayRodas: [],
      slide: 0,
      sliding: null,
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      usuarioCorrente: parseInt(SessionStorage.get('usuario'))
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    rodas () {
      if (this.$store.state.paginationAlternative.getList.data !== undefined) {
        if (this.$store.state.paginationAlternative.getList.data.length !== 0) {
          return this.$store.state.paginationAlternative.getList
        } else {
          return false
        }
      }
      return this.$store.state.paginationAlternative.getList
    }
  },
  watch: {
    rodas: function () {
      var array = []
      // var data_hora_mais_minutos = null
      // var data_hora_minutos = null
      $.each(this.rodas.data, function (key, value) {
        Vue.http.get('api/roda/buscar-vagas/' + value.id).then((response) => {
          if (response.data.success) {
            if (value.horario_inicio) {
              var hora_roda =
                value.horario_inicio.replace(/([^\d])+/gim, '') + ':01'
              var data_roda = value.data + ' ' + hora_roda
            }

            if (response.data.data.vagas_disponiveis_voluntario == 0) {
              array.push({
                vagas: 0,
                data: value.data,
                id: value.id,
                tema: value.tema,
                inscricoes: value.inscricoes,
                usuario_id: value.usuario_id
              })
            } else {
              array.push({
                vagas: response.data.data.vagas_disponiveis_voluntario,
                data: value.data,
                id: value.id,
                tema: value.tema,
                inscricoes: value.inscricoes,
                usuario_id: value.usuario_id,
                data_hora_minutos: data_roda
              })
            }
          }
        })
      })
      this.arrayRodas = array
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.perfil': function () {
      this.usuarioLogado.nome = this.usuario.nome
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    },
    municipiosprogramas: function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    usuario: function () {
      this.verificarCapacidade()
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    verificaTema (tema) {
      switch (parseInt(tema)) {
        case 1:
          return 'Tema 1'
        case 2:
          return 'Tema 2'
        case 3:
          return 'Tema 3'
        case 4:
          return 'Tema 4'
        case 5:
          return 'Tema 5'
        case 6:
          return 'Tema 6'
        case 7:
          return 'Tema 7'
        case 8:
          return 'Tema 8'
        case 9:
          return 'Tema 9'
        case 10:
          return 'Tema 10'
        case 11:
          return 'Tema 11'
        case 12:
          return 'Tema 12'
        default:
          return 'Tema 1'
      }
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    formatDate (criadoEm) {
      let date = new Date(criadoEm)

      let day = date.getDate()
      let month = date.getMonth() + 1

      if (month < 10) {
        month = '0' + month
      }

      if (day < 9) {
        day = '0' + (day + 1)
      } else {
        day = day + 1
      }

      return day + '/' + month + '/' + date.getFullYear()
    },
    navigate (route) {
      this.$router.push(route)
    },
    sair (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma a saída da roda de conversa?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get(
                'api/roda/excluir-participante/' +
                  SessionStorage.get('usuario') +
                  '/' +
                  id
              )
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearchAlternative', {
                    resource: this.resource2,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearchAlternative', {
              resource: this.resource2,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    buscaSituacao (inscricoes) {
      let inscricao = inscricoes.filter(
        (e) => e.usuario_id === this.usuarioCorrente
      )
      if (inscricao[0]) {
        inscricao[0].status
        return this.descricaoStatus(inscricao[0].status)
      } else {
        return 'Pendente'
      }
    },
    descricaoStatus: function (status) {
      let descricao = ''

      switch (status) {
        case null:
          descricao = 'Pendente'
          break
        case 0:
          descricao = 'Pendente'
          break
        case 1:
          descricao = 'Vaga Reservada'
          break
        case 2:
          descricao = 'Confirmada'
          break
        case 3:
          descricao = 'Desistente'
          break
        case 4:
          descricao = 'Não Compareceu'
          break
        case 5:
          descricao = 'Não Participou'
          break
      }
      return descricao
    },
    participar (id) {
      let data = {
        usuario_id: parseInt(SessionStorage.get('usuario')),
        id: id
      }
      this.$bvModal
        .msgBoxConfirm('Confirma a participação da roda de conversa?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http.post('api/roda/participar', data).then((response) => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearchAlternative', {
                  resource: this.resource2,
                  limit: this.totalPorPagina,
                  filtros: this.filtros
                })
              }
            })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearchAlternative', {
              resource: this.resource2,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    verificarCapacidade () {
      Vue.http
        .post('api/usuario/verificarVoluntarioCapacitado', {
          usuario_id: this.usuario.id
        })
        .then((response) => {
          if (response.data.success) {
            this.usuarioCapacitado = response.data.data.capacitado
          }
        })
    },
    loadInformacoes () {
      Vue.http.get('api/informacao/usuario').then((response) => {
        if (response.body.success) {
          this.informacoes = response.body.data
        }
      })
    },
    loadProgramas () {
      Vue.http
        .get('api/programaDeMunicipio/usuario?vigente=true')
        .then((response) => {
          if (response.body.success) {
            this.programas = response.body.data[0]
          }
        })
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
    abrirLink (link) {
      window.open(link, '_blank')
    },
    modalprograma (id) {
      this.modalprog = true
      Vue.http.get('api/programaDeMunicipios/' + id).then((response) => {
        if (response.body.success) {
          this.prog = response.body.data
        }
      })
    },
    fecharmodalprog (id) {
      this.modalprog = false
      this.prog = []
    },
    modalinformacao (id) {
      this.modalinfo = true
      Vue.http.get('api/informacoes/' + id).then((response) => {
        if (response.body.success) {
          this.info = response.body.data
        }
      })
    },
    fecharmodalinfo (id) {
      this.modalinfo = false
      this.info = []
    },
    verificaTexto (texto) {
      if (texto.length >= 100) {
        return texto.substring(0, 100).concat('...')
      } else {
        return texto
      }
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
.row {
  margin-top: 20px;
}
img {
  width: 260px;
  height: 220px;
}

.card article {
  cursor: pointer;
}

div .limit-body {
 height: 170px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/voluntario/PrincipalVoluntario.vue